import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const SortIconSvg: FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 24 25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_1538_6568"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="25"
      >
        <rect y="0.198242" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1538_6568)">
        <path
          d="M4.25 17.6982C4.0375 17.6982 3.85942 17.6263 3.71575 17.4825C3.57192 17.3387 3.5 17.1605 3.5 16.948C3.5 16.7353 3.57192 16.5572 3.71575 16.4137C3.85942 16.2701 4.0375 16.1982 4.25 16.1982H8.125C8.3375 16.1982 8.51558 16.2702 8.65925 16.414C8.80308 16.5578 8.875 16.736 8.875 16.9485C8.875 17.1612 8.80308 17.3392 8.65925 17.4827C8.51558 17.6264 8.3375 17.6982 8.125 17.6982H4.25ZM4.25 12.9482C4.0375 12.9482 3.85942 12.8763 3.71575 12.7325C3.57192 12.5887 3.5 12.4105 3.5 12.198C3.5 11.9853 3.57192 11.8072 3.71575 11.6637C3.85942 11.5201 4.0375 11.4482 4.25 11.4482H13.9327C14.1452 11.4482 14.3233 11.5202 14.467 11.664C14.6108 11.8078 14.6827 11.986 14.6827 12.1985C14.6827 12.4112 14.6108 12.5892 14.467 12.7327C14.3233 12.8764 14.1452 12.9482 13.9327 12.9482H4.25ZM4.25 8.19824C4.0375 8.19824 3.85942 8.12633 3.71575 7.98249C3.57192 7.83866 3.5 7.66049 3.5 7.44799C3.5 7.23533 3.57192 7.05724 3.71575 6.91374C3.85942 6.77008 4.0375 6.69824 4.25 6.69824H19.75C19.9625 6.69824 20.1406 6.77016 20.2843 6.91399C20.4281 7.05783 20.5 7.23599 20.5 7.44849C20.5 7.66116 20.4281 7.83924 20.2843 7.98274C20.1406 8.12641 19.9625 8.19824 19.75 8.19824H4.25Z"
          fill={props.fill || '#6B6A76'}
        />
      </g>
    </svg>
  )
}

export const SortIcon = createStandardIcon(SortIconSvg)
